import fetcher from './fetcher';
// import { dummyData } from './';
import { ILookupResult } from '../../shared-types';
import {
  IFundSearchRequest,
  IFundSearchResult,
  IFundSearchFund,
} from '../types';

import {
  hasAuthStream,
  fetchFromClass,
  FetchJob,
} from '../utils/class-auth-fetch-service';

export function convertToSearchBarResult(
  apiFund: IFundSearchFund,
  captionProp: string,
  searchTerm: string
): ILookupResult {
  const fullEntityType = apiFund.entityType || '';
  const entityType =
    fullEntityType.length > 0 ? fullEntityType.substr(0, 1) : ' ';
  return {
    label: apiFund.name,
    sublabel: apiFund.code,
    entityType,
    fullEntityType,
    href: `/${apiFund.url}`,
    target: '_blank',
    shortcut: '',
  };
}

// function fetchMock(searchTerm: string) {
//   return new Promise<IFundSearchResult | { error: string }>(
//     (resolve, reject) => {
//       if (searchTerm.toLowerCase().includes('error')) {
//         setTimeout(() => reject('some error message'), 5000);
//       } else {
//         setTimeout(() => resolve(dummyData), 5000);
//       }
//     }
//   );
// }

function fetchDirect(
  searchTerm: string,
  endpoint: string,
  accessToken: string
) {
  const requestData: IFundSearchRequest = {
    searchHint: searchTerm,
  };
  const param = new URLSearchParams(requestData as any);
  return fetcher<IFundSearchResult, IFundSearchRequest>(
    `${endpoint}?${param.toString()}`,
    {
      method: 'GET',
      headers: { Authorization: `Bearer ${accessToken}` },
    }
  );
}
function patchRequestInit(
  bearerToken: string,
  request: RequestInit
): RequestInit {
  return {
    ...request,
    headers: {
      ...request.headers,
      Authorization: `Bearer ${bearerToken}`,
    },
  };
}
function fetchByAuthService(
  searchTerm: string,
  endpoint: string
) {
  return new Promise<IFundSearchResult | { error: string }>(
    (resolve, reject) => {
      fetchFromClass(
        new FetchJob({
          retryCount: 2,
          failedCallback: reject,
          fetchCallback: async (bearerToken: string) => {
            try {
              const response = await fetchDirect(
                searchTerm,
                endpoint,
                bearerToken
              );
              resolve(response);
            } catch (err) {
              reject(err);
            }
          },
        })
      );
    }
  );
}

export default async function fetchFundSearchResults(
  searchTerm: string,
  endpoint: string,
  accessToken: string
) {
  // // !! using mock data
  // const p = fetchMock(searchTerm);
  let p: Promise<IFundSearchResult | { error: string }>;
  if (hasAuthStream()) {
    // auth stream presents, and no access token assigned
    // use auth service to fetch
    p = fetchByAuthService(searchTerm, endpoint);
  } else {
    p = fetchDirect(searchTerm, endpoint, accessToken);
  }

  const response = await p;
  const funds = response as IFundSearchResult;
  const errRes = response as { error: string };

  if (errRes.error) {
    console.info('ERROR: fetch failed:', response);
    if (errRes.error === 'empty result') {
      return [];
    } else {
      throw errRes.error;
    }
  }

  const matches =
    (funds.funds ?? [])
      .map((f) => convertToSearchBarResult(f, 'code', searchTerm))|| [];
  return matches;
}
